
import { computed, defineComponent, PropType, toRefs, watch } from 'vue'
import moment from 'moment'
import { ValidationRule } from 'quasar/dist/types/api'

interface MonthOption {
    label: string
    value: string
}

export default defineComponent({
    props: {
        modelValue: {
            type: String as PropType<string>,
            required: false
        },
        startDate: {
            type: Date as PropType<Date>,
            required: true
        },
        endDate: {
            type: Date as PropType<Date>,
            required: true
        },
        interval: {
            type: Number as PropType<number>,
            default: 1
        },
        invoicingFrom: {
            type: String as PropType<string>,
            required: true
        },
        validationRules: {
            type: Array as PropType<ValidationRule[]>,
            default: () => []
        }
    },
    emits: ['update:modelValue', 'scheduledPrices:revalidateForm'],
    setup (props, { emit }) {
        const { modelValue, startDate, endDate, interval, invoicingFrom } = toRefs(props)

        const localModel = computed({
            get: () => props.modelValue,
            set: value => emit('update:modelValue', value)
        })

        const formatMothToDisplay = (date: Date) => {
            const currentDate = new Date(date)
            return new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(currentDate)
        }

        const generateSelectableMonths = () => {
            let selectableMonths: MonthOption[] = []
            const currentDate = new Date(invoicingFrom.value)
            while (currentDate <= endDate.value) {
                selectableMonths.push({
                    label: formatMothToDisplay(currentDate),
                    value: moment(currentDate).startOf('month').format('YYYY-MM-DD')
                })
                currentDate.setMonth(currentDate.getMonth() + interval.value)
            }
            selectableMonths = selectableMonths.filter(month => month.value >= moment(startDate.value).format('YYYY-MM-DD'))
            return selectableMonths
        }

        const selectedMonth = modelValue.value
        const selectableMonths = generateSelectableMonths()
        const handleMonthChange = (value: string) => {
            emit('update:modelValue', value)
        }

        watch(localModel, () => {
            emit('scheduledPrices:revalidateForm')
        })

        return {
            localModel,
            selectedMonth,
            selectableMonths,
            handleMonthChange,
            formatMothToDisplay
        }
    }
})
